import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=749ae20d&scoped=true&lang=pug&"
import script from "./FormBody.vue?vue&type=script&lang=js&"
export * from "./FormBody.vue?vue&type=script&lang=js&"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=749ae20d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ae20d",
  null
  
)

export default component.exports